import { InputHTMLAttributes, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, ButtonProps } from '../Button/Button';
import { Stack } from '../Stack/Stack';

export type FileInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  helperText?: string;
  className?: string;
  fileName?: string;
  buttonText?: string;
} & Partial<ButtonProps>;

export const FileInput = ({
  className,
  helperText,
  disabled,
  variant = 'outline',
  fileName,
  loading,
  leftAdornment,
  rightAdornment,
  label,
  asChild,
  buttonText,
  ...props
}: FileInputProps) => {
  const { t } = useTranslation();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const fallbackButtonText = t('global.misc.uploadFile');

  return (
    <Stack className='w-fit' spacing={2}>
      <Stack direction='row' className='items-center' spacing={2}>
        <Button
          onClick={() => fileInputRef.current?.click()}
          disabled={disabled}
          variant={variant}
          className={className}
          loading={loading}
          leftAdornment={leftAdornment}
          rightAdornment={rightAdornment}
          label={label}
          asChild={asChild}
        >
          {buttonText ?? fallbackButtonText}
        </Button>
        {fileName && <span className='typography-body1'>{fileName}</span>}
      </Stack>
      <input type='file' ref={fileInputRef} className='hidden' disabled={disabled} {...props} />
      {helperText && <div className='typography-caption'>{helperText}</div>}
    </Stack>
  );
};

FileInput.displayName = 'FileInput';
